import { Fragment, useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { otpResultado, trackEvent } from "../../services/analytics/track";
import Countdown from "react-countdown";
import { digitosFirma } from "../../components/legal/Otp";
import { HttpRequest } from "../../services/httpRequest";
import { SuccessAlert } from "../../components/alerts/successAlert";
import { ErrorAlert } from "../../components/alerts/errorAlert";
import { ProgressLinear } from "../../components/progress/progressLinear";
import { AuthContext } from "../../context/Auth/AuthContext";
import { variablesGlobales } from "../../configs/variables";
import { Login } from "../../components/backgrounds/Login";
import { useMobileDetection } from "../../hooks/use-mobile-detection";
import OtpComponente from "../../components/new_components/Otp";
import { NextButton } from "../../components/new_components/buttonsFlow";
import { ChevronLeft } from "lucide-react";

export function VerificationPhonePage() {
  const { token } = useContext(AuthContext);

  const navigate = useNavigate();
  const { state } = useLocation();
  const phone = state?.phone || localStorage.getItem("phone") || "3002009876";
  const emailUser = state?.email || "";
  const doc = state?.doc || "";
  const celularProtect = "********" + phone.substring(8);
  const { isDesktop, screenHeight } = useMobileDetection();

  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState();
  const [isOpenError, setIsOpenError] = useState();
  const [viewalert, setViewalert] = useState(false);
  const [viewProgress, setViewProgress] = useState(false);
  const [showCountDown, setShowCountDown] = useState(false);
  const [formDataOtp, setFormDataOtp] = useState({
    otp: "",
  });
  const [errors, setErrors] = useState({});

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(true);
    }
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(true);
    }
  };

  const handleProgress = (isView) => {
    setViewProgress(isView);
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);
  };

  const reeenviarToken = async (e) => {
    e.preventDefault();
    trackEvent("otp_reenviado", { contexto: "registro" });

    if (showCountDown === true) {
      setShowCountDown(false);
    }

    let payload = Object.assign({}, { doc: doc });

    try {
      const responseService = await HttpRequest.loginRequestSms(payload);
      setShowCountDown(true);
      if (responseService.error) {
        if (responseService.message.code === "NOTEXISTUSER") {
          handleOpenAlert(
            "error",
            "Ups! El usuario no existe con el documento ingresado.",
            true,
          );
          return setTimeout(() => {
            localStorage.clear();
            navigate("/registrarse");
          }, 5000);
        } else if (responseService.message.code === "ACCOUNTBLOCK") {
          handleOpenAlert(
            "error",
            `Ups! ${responseService.message.message}`,
            true,
          );
          return;
        } else if (responseService.message.code === "INVALIDCREDENTIALS") {
          handleOpenAlert(
            "error",
            `Ups! ${responseService.message.message}`,
            true,
          );
          return;
        } else if (responseService.message.code === "OTP_RATE_LIMIT") {
          handleOpenAlert(
            "error",
            `Ups! ${responseService.message.message}`,
            true,
          );
          return;
        }

        handleOpenAlert(
          "error",
          "Ups! Error interno, intenta nuevamente",
          true,
        );
        return;
      } else {
        handleOpenAlert("success", `Token enviado exitosamente!`, true);
      }
    } catch (error) {
      handleOpenAlert("error", `Ups! ${error.message.message}`, true);
      return;
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleSubmit = async (event) => {
    setIsLoading(true);
    setIsDisabled(true);
    try {
      handleClearStateAlert();

      event.preventDefault();

      handleProgress(true);

      let payload = Object.assign({}, { doc: doc, otp: token });

      const responseService =
        await HttpRequest.validateTokenSessionVisitor(payload);
      trackEvent("otp_verificado", { contexto: "registro", resultado: otpResultado(responseService) });

      if (responseService.error) {
        setIsLoading(false);
        setIsDisabled(false);
        if (responseService.message.code === "NOTEXISTUSER") {
          handleOpenAlert("error", responseService.message, true);
          handleProgress(false);
          return;
        } else if (responseService.message.code === "ACCOUNTBLOCK") {
          handleOpenAlert("error", responseService.message, true);
          handleProgress(false);
          return;
        } else if (responseService.message.code === "INVALIDTOKEN") {
          handleOpenAlert("error", responseService.message?.message, true);
          handleProgress(false);
          return;
        }

        handleOpenAlert("error", "Ups! Error interno, intente más tarde", true);
        handleProgress(false);
        return;
      }

      setTimeout(() => {
        localStorage.setItem("doc", doc);
        localStorage.setItem("is_signin", true);
        localStorage.setItem("token", responseService.message.otp);
        localStorage.setItem("token_jwt", responseService.message.tokenJwt);
        localStorage.setItem("type_user", variablesGlobales.typeUserVisitor);
        handleProgress(false);
        return navigate("/request-credit", { replace: true, state: {} });
        /* return navigate("/formulariouno", { replace: true, state: {} }); */
      }, 3000);
    } catch (error) {
      console.log(error);
      handleProgress(false);
      return navigate("/");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormDataOtp((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    setIsDisabled(false);
  };

  useEffect(() => {
    const previousBackground = document.body.style.background;

    document.body.style.background = "#000000";
    document.body.style.margin = "0";
    document.body.style.padding = "0";

    return () => {
      document.body.style.background = previousBackground;
      document.body.style.margin = "";
      document.body.style.padding = "";
    };
  }, []);

  const getFormMarginTop = () => {
    if (screenHeight <= 199) return "460px";
    if (screenHeight <= 299) return "420px";
    if (screenHeight <= 399) return "380px";
    if (screenHeight <= 499) return "340px";
    if (screenHeight <= 515) return "300px";
    if (screenHeight <= 565) return "260px";
    if (screenHeight <= 599) return "220px";
    if (screenHeight <= 655) return "180px";
    if (screenHeight <= 699) return "140px";
    if (screenHeight <= 750) return "100px";
    if (screenHeight >= 751) return "10px";
  };

  const BtnReenviarToken = () => {
    return (
      <div className="items-center pb-10">
        <div className="block text-center">
          <a href="/" onClick={reeenviarToken} className="text-purple underline">
            Reenviar código
          </a>
        </div>
      </div>
    );
  };

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      return <BtnReenviarToken />;
    } else {
      // Render a countdown
      return (
        <span>
          {hours}:{minutes}:{seconds}
        </span>
      );
    }
  };

  return (
    <Fragment>
      {viewalert ? (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
          ></SuccessAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      ) : (
        <></>
      )}

      {isDesktop && (
        <>
          <div
            class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
            <div class="flex flex-row items-center justify-center gap-4 mr-2">
              <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                  alt="colombia fintech" />
              </div>

              <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                  alt="Superintendencia de Industria y Comercio" />
              </div>
            </div>
            <span
              class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
              Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
              Colombia con NIT: 901.582.748-5
            </span>

          </div>
        </>
      )}

      <Login
        classVeri="mt-16"
        form={
          <form
            className="
              space-y-6
              w-full
              max-w-[440px]
              min-h-135.5
              mx-auto
              px-5
              sm:px-10
              flex flex-col items-center
            "
            onKeyDown={handleKeyDown}
            style={{
              background:
                "linear-gradient(145deg, rgba(28,18,43,0.95) 0%, rgba(13,9,20,0.98) 100%)",
              borderRadius: "25px",
              display: "flex",
              flexDirection: "column",
              border: "1px solid #FFFFFF1A",
              justifyContent: "space-around",
              marginTop: !isDesktop && getFormMarginTop(),
            }}
          >
            <div
              className="flex justify-start w-full"
              style={{
                gap: isDesktop ? "60px" : "30px",
              }}
            >
              <button
                onClick={() => {
                  navigate("/");
                }}
                style={{ cursor: "pointer" }}
              >
                <ChevronLeft
                  className={`w-7 h-7 text-white`}
                  strokeWidth={2.5}
                />
              </button>
              <img
                className="h-12 w-48 cursor-pointer"
                src="/svg/imagotipo-galilea-02.svg"
                alt="Galilea"
                onClick={() => {
                  navigate("/");
                }}
              />
            </div>
            <div className="text-center block">
              <div className="mb-5">
                <h2
                  className="text-2xl md:text-2xl font-bold text-center text-white"
                  autoFocus
                >
                  <div>{"Verificación de seguridad"}</div>
                </h2>
                <p className="mt-1 text-sm leading-6 text-center text-grayP">
                  {`Digita el código de ${digitosFirma} dígitos que hemos enviado a tu celular ${celularProtect}.`}
                </p>
              </div>

              {/* <Otp name="tokensms" id="tokensms" /> */}
              <div className="flex w-full justify-evenly">
                <OtpComponente
                  name="tokensms"
                  id="tokensms"
                  value={formDataOtp.otp}
                  onChange={handleInputChange}
                  isDesktop={isDesktop}
                ></OtpComponente>
              </div>
            </div>
            <div className="pt-8">
              <div>
                {viewProgress ? (
                  <Fragment>
                    <ProgressLinear></ProgressLinear>
                    <p className="text-white">
                      Estamos verificando el código, por favor espera...
                    </p>
                  </Fragment>
                ) : (
                  <NextButton
                    label={"Verificar código"}
                    isLastStep={false}
                    showIconNext={false}
                    onNext={(e) => {
                      handleSubmit(e);
                    }}
                    isLoading={isLoading}
                    disabled={isDisabled}
                    isUnicButtom={true}
                  />
                )}
              </div>
            </div>

            {showCountDown === true ? (
              <div className="items-center pb-10">
                <div className="block text-center countdown-reenviartoken">
                  <Countdown date={Date.now() + 60000} renderer={renderer} />
                </div>
              </div>
            ) : (
              <div className="items-center">
                <div className="block text-center">
                  <button
                    type="button"
                    onClick={reeenviarToken}
                    className="text-[#A78BFA]"
                  >
                    Reenviar código
                  </button>
                </div>
              </div>
            )}
          </form>
        }
        message={
          <span className="flex justify-center pt-10 mx-auto text-lg">
            ¿No tienes acceso a tu celular?{" "}
            <a
              href="/autenticarse-email"
              state={{ email: emailUser, doc: doc, isSendToken: true }}
              className="text-purple pl-2 underline"
            >
              {" "}
              Intenta con tu correo.{" "}
            </a>
          </span>
        }
      />
    </Fragment>
  );
}
